import * as firebase from "firebase/app";

const firebaseProviders = {
  Google: new firebase.auth.GoogleAuthProvider(),
  Correo: new firebase.auth.EmailAuthProvider(),
};

export default firebaseProviders;
